export default [
  {
    id: 1,
    name: { it: "Finiture colore", en: "Colour finishes" },
    finishes: [
      {
        name: "01 bianco",
        description: "basic",
        image: require("./images/01bianco.jpeg"),
      },
      {
        name: "50 nuvola",
        description: "basic",
        image: require("./images/50nuvola.jpeg"),
      },
      {
        name: "3c canapa",
        description: "basic",
        image: require("./images/3ccanapa.jpeg"),
      },
      {
        name: "20 cashmere",
        description: "smart",
        image: require("./images/20cashmere.jpeg"),
      },
      {
        name: "55 sabbia",
        description: "smart",
        image: require("./images/55sabbia.jpeg"),
      },
      {
        name: "52 basalto",
        description: "smart",
        image: require("./images/52basalto.jpeg"),
      },
      {
        name: "25 cemento",
        description: "smart",
        image: require("./images/25cemento.jpeg"),
      },
      {
        name: "16 lavagna",
        description: "smart",
        image: require("./images/16lavagna.jpeg"),
      },
    ],
  },
  {
    id: 2,
    name: { it: "Finiture ecolegno", en: "Eco-wood finishes" },
    finishes: [
      {
        name: "28 olmo shade",
        description: "smart",
        image: require("./images/28olmo.jpeg"),
      },
      {
        name: "39 toulipier",
        description: "smart",
        image: require("./images/39toulipier.jpg"),
      },
      {
        name: "80 rovere",
        description: "smart",
        image: require("./images/80rovere.jpeg"),
      },
      {
        name: "54 noce",
        description: "smart",
        image: require("./images/54noce.jpeg"),
      },
    ],
  },
  {
    id: 3,
    name: { it: "Finiture materiche", en: "Textured finishes" },
    finishes: [
      {
        name: "57calce",
        description: "smart",
        image: require("./images/57calce.jpeg"),
      },
      {
        name: "77intonaco",
        description: "smart",
        image: require("./images/77intonaco.jpeg"),
      },
    ],
  },
  {
    id: 4,
    name: { it: "Vetro standard", en: "Standard glass" },
    finishes: [
      {
        name: "VE vetro trasparente",
        description: "VE trasparent glass",
        image: require("./images/VE.jpeg"),
      },
      {
        name: "VF vetro fumè",
        description: "VF smoked glass",
        image: require("./images/VF.jpeg"),
      },
    ],
  },
  {
    id: 5,
    name: { it: "Vetro acidato", en: "Etched glass" },
    finishes: [
      {
        name: "VA vetro acidato",
        description: "VA etched glass",
        image: require("./images/VA.jpeg"),
      },
    ],
  },
  {
    id: 6,
    name: { it: "Vetro laccato", en: "Lacquered glass" },
    finishes: [
      {
        name: "VB vetro bianco",
        description: "VB white glass",
        image: require("./images/VB.png"),
      },
      {
        name: "VN vetro nero",
        description: "VN black glass",
        image: require("./images/VN.png"),
      },
    ],
  },
  {
    id: 7,
    name: { it: "Specchio", en: "Mirror" },
    finishes: [
      {
        name: "SP specchio chiaro",
        description: "SP light mirror",
        image: require("./images/SP.jpeg"),
      },
      {
        name: "SR specchio brunito",
        description: "SR tinted mirror",
        image: require("./images/SR.jpeg"),
      },
    ],
  },
  {
    id: 8,
    name: { it: "Finiture metalliche", en: "Metal finishes" },
    finishes: [
      { name: "6Z nichel", image: require("./images/6Z.jpeg") },
      { name: "5Z titanio", image: require("./images/5Z.jpeg") },
      { name: "3G grafite", image: require("./images/3G.jpeg") },
      { name: "01 bianco", image: require("./images/01.jpeg") },
      { name: "16 lavagna", image: require("./images/16.jpeg") },
    ],
  },
  {
    id: 9,
    name: { it: "Finiture colore", en: "Colour finishes" },
    finishes: [
      {
        name: "50 nuvola",
        description: "basic",
        image: require("./images/50nuvola.jpeg"),
      },
    ],
  },
];
